var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',_vm._g({attrs:{"first-day-of-week":_vm.firstDayOfWeek}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }